import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import styled from "styled-components";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import {
  FC,
  ReactElement,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import documentSVG from "../../assets/document.svg";
import DeleteIcon from "../../assets/Delete.svg";
import EditIcon from "../../assets/edit.svg";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import styles from "../../components/MoveOutTerminationTabs/styles.module.scss";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toast } from "react-toastify";
import cardsStore from "../../stores/CardsStore";
import { Modal } from "@mui/material";
import CardsPopup from "../MoveOutTerminationTabs/CardsPopup";
import Accounts from "./Accounts";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import AmountEdit from "./AmountEdit";
import ChangeCardModal from "./ChangeCardModal";
import { useLocation } from "react-router-dom";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";
import generalStore from "../../stores/GeneralStore";
import { set, toJS } from "mobx";
import DelCardModal from "./DeleteCard";
import constants from "../../utils/constants";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";
import DisableAutopay from "./DisableAutopay";

declare global {
  interface Window {
    NI: any;
  }
}
interface TokenData {
  token: string; // The session_id from generateSessionId()
  card?: {
    // Optional card details object
    expiryMonth?: string;
    expiryYear?: string;
    last4?: string;
    paymentMethod?: string;
  };
}

interface AppConfig {
  "isCheckout" : boolean,
  "ApiKey" : string,
  "OutletRef" : string
  "NIUrl": string
}

interface Obj {
  [key: string]: any;
}

interface Props extends BaseProps {
  saveAndUpdate: (files: any) => Promise<void>;
}
const AutoPay = (): ReactElement => {
  const ColorAss = generalStore?.ColorAss;
  const contrast = generalStore?.contrast;

  const [cardsPopupModal, setCardsPopupModal] = useState(false);
  const [accountsModal, setAccountsModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dateValue, setDateValue] = useState<any>();
  const [previousPaymentId, setpreviousPaymentId] = useState();
  const [cardChange, setCardChange] = useState(false);
  const [changeCardData, setChangeCardData] = useState<any>();

  const [niCardModal, setNICardModal] = useState(false);
  const [ni3dsModal, setNi3dsModal] = useState(false);

  const [tokenizedCard, setTokenizedCard] = useState<any>(null);
  const [niLoading, setNILoading] = useState(false);
  const [niInitialized, setNIInitialized] = useState(false);
  const [isCardInputValid, setIsCardInputValid] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const handleOpen = () => {
    setTokenizedCard(null);
    // setNIInitialized(false);
    setNICardModal(true);
  };

  const handleClose = () => {
    setNICardModal(false);
    setTimeout(() => {
      setTokenizedCard(null);
      setNIInitialized(false);
      setNILoading(false);
      setAgreeTerms(false);
    }, 300);
  };

  const location = useLocation();
  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === "CHECKOUT";
  const [config, setConfig] = useState<AppConfig | null>(null);


   useEffect(() => {
       async function loadConfig() {
         try {
           const response = await fetch('/config/config.json'); 
           const json = await response.json();
           setConfig(json);
         } catch (err) {
           console.error("Error loading config:", err);
         }
       }
       loadConfig();
     }, []);

  const handleSaveCard = async () => {
    if(!isOnline){
      toast.error(General?.codeLabels["cm_internet_disconnected"]?.label || "No internet connection. Please check your connection and try again.",{autoClose: 3000,});
      return;
    }
    if (
      !niInitialized ||
      !window.NI ||
      typeof window.NI.generateSessionId !== "function"
    ) {
      toast.error(General?.codeLabels["cm_service_not_ready"]?.label || "Payment service not ready. Please wait or try again.",
        {
          autoClose: 3000,
        }
      );
      return;
    }

    setNILoading(true);

    try {
      // Check internet connection before proceeding
      if (!navigator.onLine) {
        throw new Error("Internet connection lost. Please check your connection and try again.");
      }
      const response = await window.NI.generateSessionId();
      console.log("Session ID Generated:", response.session_id);

      if (!response?.session_id) {
        throw new Error("Session ID missing in response");
      }

      const res = await cardsStore.saveCard({
        errorId: "savecard",
        data: { sessionId: response.session_id },
      });
      const paymentResponse = res?.result;

       if (
        !paymentResponse ||
        (
          !paymentResponse._links?.["cnp:3ds"]?.href &&
          !paymentResponse._links?.["cnp:3ds2"]?.href
        ) ||
        (
          !paymentResponse["3ds"] &&
          !paymentResponse["3ds2"]
        )
      ) {
        console.error("3DS/3DS2 link missing — cannot continue", paymentResponse);
        toast.error(
          General?.codeLabels["cm_invalid_card"]?.label ||
            "Invalid or unsupported card. Please use a valid card.",
          { autoClose: 3000 }
        );
        setNILoading(false);
        setNICardModal(false);
        setNi3dsModal(false);
        return;
      }
      handleClose();
      setNi3dsModal(true);
      setTimeout(async () => {
        const handleResult = await window.NI.handlePaymentResponse(
          paymentResponse,
          {
            mountId: "ni-3ds-frame",
            // style: { width: 500, height: 500 },
          }
        );

        const { status } = handleResult || {};

        if (
          status === window.NI.paymentStates.AUTHORISED ||
          status === window.NI.paymentStates.CAPTURED ||
          status === window.NI.paymentStates.VERIFIED
        ) {
          externalPayment3DS(paymentResponse.orderReference, 6);
        } else {
          toast.error(General?.codeLabels["cm_authentication_failed"]?.label || "Authentication failed. Please try again with a valid card.",
          {
            autoClose: 3000,
          }
        );
          setNi3dsModal(false);
          throw new Error(`3DS verification failed with status: ${status}`);
        }
      }, 200);
    } catch (err) {
      console.error("Error during NI card save:", err);       
         toast.error(General?.codeLabels["cm_card_save_process_msg"]?.label || "Error during NI card processing",{ autoClose: 3000,}
        ); 
      
      setNi3dsModal(false);
    } finally {
      setNILoading(false);
    }
  };

  const externalPayment3DS = async (sessionId: string, type: any) => {
    const data = { sessionId, type, isSavedCard: true };

    try {
      const res = await General.externalPayment3DS({
        errorId: "updatePayment",
        data,
      });
      if (!General?.paymentUpdateResponse.isError) {
        if (window.NI && typeof window.NI.unMountCardInputs === "function") {
          window.NI.unMountCardInputs();
        }
        toast.success(General?.codeLabels["cm_card_verified"]?.label || "Card verified & saved successfully!",
          {
            autoClose: 3000,
          }
        );
        setNi3dsModal(false);
        cardsStore.getCardsList({ errorId: "getCardsListError" });
      } else {
        if (window.NI && typeof window.NI.unMountCardInputs === "function") {
          window.NI.unMountCardInputs();
        }
        setNi3dsModal(false);
        toast.error(General?.codeLabels["cm_card_failed"]?.label || "Card saving failed!",
          {
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      if (window.NI && typeof window.NI.unMountCardInputs === "function") {
          window.NI.unMountCardInputs();
        }
      toast.error(General?.codeLabels["cm_card_failed"]?.label || "Card saving failed!",
          {
            autoClose: 3000,
          }
        );
    }
  };

  //disable autopay
  const [disableAutoPayModal, setDisableAutoPayModal] = useState(false);
  const [disablePymentDetails, setDisablePaymentDetails] = useState<{previousPaymentId: string;accountId: string;} | null>(null);


  const openDisableAutopayModal = (previousPaymentId : string, accountId: string) => {
    setDisablePaymentDetails({previousPaymentId, accountId});
    setDisableAutoPayModal(true);
  }
  const closeDisableAutopayModal = () =>{
    setDisableAutoPayModal(false);
    setDisablePaymentDetails(null);
  }
  const handleDisableAutoPay = async(payload:{previousPaymentId: string;accountId: string;}) =>{
    try{
      const response = await cardsStore.disableAutopay({ errorId: "disableAutopay", data: payload });
      if(response?.message == "Success"){      
        cardsStore.list.cards = cardsStore.list.cards.map((card: any) => {
        if (card.previousPaymentId === payload.previousPaymentId) {
          return {
            ...card,
            accounts: card.accounts.filter(
              (acc: any) => acc.accountNo !== payload.accountId
            ),
          };
        }
        return card;
      });  
        setDisableAutoPayModal(false);
        toast.success(response?.result?.message,{autoClose:3000});
      }
      else {
        setDisableAutoPayModal(false);
        toast.error(General?.codeLabels["cm_autopay_disable_failed"]?.label !== undefined ? General?.codeLabels["cm_autopay_disable_failed"]?.label :"Failed to disable AutoPay.",{autoClose:3000});
      }
    }catch(error){
      setDisableAutoPayModal(false);
      toast.error(General?.codeLabels["cm_autopay_disable_error"]?.label !== undefined ? General?.codeLabels["cm_autopay_disable_error"]?.label :"An error occurred while disabling AutoPay.");
    }
  }


  const handleOpenCardsPopupModal = () => {
    setCardsPopupModal(true);
  };
  const handleCloseCardChange = () => {
    setCardChange(false);
  };
  const handleCloseCardsPopupModal = () => {
    setCardsPopupModal(false);
  };

  const handleOpenAccountsModal = async () => {
    setAccountsModal(true);
  };

  const handleCloseAccountsModal = () => {
    setAccountsModal(false);
  };
  const [paymentLoader, setPaymentLoader] = useState(false);
  const handleMakePayment = async (cardData: any) => {
    setPaymentLoader(true);
    // await cardsStore?.addCard(cardData)
  };
  const [saveAccLoader, setsaveAccLoader] = useState(false);
  const handleSaveAccounts = async (payload: any) => {
    setsaveAccLoader(true);
    const data = {
      accounts: payload,
      previousPaymentId:
        location.state && location.state.autoPay
          ? General?.paymentUpdateResponse?.previousPaymentId
          : previousPaymentId,
    };
    const res = await cardsStore.addAccount({ errorId: "addAccount", data });
    if (res?.message == "cm_success_msg") {
      toast?.success(General?.codeLabels[res?.message]?.label || "Account added successfully!");
      handleCloseAccountsModal();
      setsaveAccLoader(false);
    }
    setsaveAccLoader(false);
  };
  const handleOpenEditModal = (account: any, card: any) => {
    const data = { account, card };
    setEditModal(true);
    setDateValue(data);
  };
  const [chosenCard, setChosenCard] = useState<any>();
  const [delModalOpen, setDELModalOpen] = useState(false);
  const handleOpenDeleteModal = (card: any) => {
    setChosenCard(card);
    setDELModalOpen(true);
  };
  const [loader, setLoader] = useState(false);
  const handleDeleteCard = async () => {
    setLoader(true);
    const data = chosenCard;
     await cardsStore?.deleteCard({
    errorId: "deleteCard",
    data: {
      previousPaymentId: chosenCard?.previousPaymentId,
      gatewayCdField: chosenCard?.gatewayCdField || "",
    },
  });

    setLoader(false);
    setDELModalOpen(false);
  };
  const handleChangeCard = async (data: any) => {
    const res = await cardsStore?.changeDate({ errorId: "changeDate", data });
    setCardChange(false);
  };
  const [editLoader, setEditLoader] = useState(false);
  const handleChangeDate = async (data: any) => {
    setEditLoader(true);
    const res = await cardsStore?.changeDate({ errorId: "changeDate", data });
    if (res?.message == "Success") {
      setEditLoader(false);
      setEditModal(false);
    }
  };
  useEffect(() => {
    cardsStore.getCardsList({ errorId: "getCardsListError" });
    if (location.state && location.state.autoPay) {
      setAccountsModal(true);
      setpreviousPaymentId(
        General?.paymentUpdateResponse?.result?.previousPaymentId
      );
    }
  }, []);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
  const handleOnline = () => {
    setIsOnline(true);
  };
  const handleOffline = () => {
    setIsOnline(false);
  };

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
}, []);

  useEffect(() => {
    if (cardsStore.addedCardResponse.redirectRequired) {
      window.open(cardsStore.addedCardResponse.redirectUrl, "_self");
      handleCloseCardsPopupModal();
    }
  }, [cardsStore.addedCardResponse]);

  const editIcon = (color: string) => {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.5583 4.19165L45.8083 10.4417L41.0438 15.2083L34.7938 8.95832L39.5583 4.19165ZM16.6667 33.3333H22.9167L38.0979 18.1521L31.8479 11.9021L16.6667 27.0833V33.3333Z"
          fill={color}
        />
        <path
          d="M39.5833 39.5833H16.9958C16.9417 39.5833 16.8854 39.6042 16.8313 39.6042C16.7625 39.6042 16.6938 39.5854 16.6229 39.5833H10.4167V10.4167H24.6813L28.8479 6.25H10.4167C8.11875 6.25 6.25 8.11667 6.25 10.4167V39.5833C6.25 41.8833 8.11875 43.75 10.4167 43.75H39.5833C40.6884 43.75 41.7482 43.311 42.5296 42.5296C43.311 41.7482 43.75 40.6884 43.75 39.5833V21.525L39.5833 25.6917V39.5833Z"
          fill={color}
        />
      </svg>
    );
  };

  useEffect(() => {
    if (!niCardModal) return;

    const scriptId = "ngenius-sdk-script";

    const initWhenReady = () => {
      const mountTarget = document.getElementById("ni-card-mount");
      if (!mountTarget) {
        console.warn("NI mount target not found yet, retrying...");
        setTimeout(initWhenReady, 100); // wait for modal to fully render
        return;
      }

      if (!window.NI) {
        console.error("NI SDK object (window.NI) not found.");
        return;
      }

      console.log("Mounting NI Card Inputs...");
      const style = {
  // Global field defaults
  base: {
    color: "#232323ff",
    fontSize: "16px",
    fontFamily: "Segoe UI",
    fontWeight: "500",
    backgroundColor: "#ffffff",

    // placeholder
    "::placeholder": {
      color: "#999999",
    },
  },

  // Each input box
  input: {
    padding: "12px",
    border: "0.5px solid #d9d9d9 !important",
    backgroundColor: "#ffffff",
  },

  // On focus
  focus: {
    border: "1px solid #007bff",
    boxShadow: "0px 0px 4px rgba(0, 123, 255, 0.4)",
  },

  // On error
  invalid: {
    color: "#D32F2F",
    border: "1px solid #D32F2F !important",
  },

  // Field label styling
  label: {
    color: "#0e160a !important",
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "6px",
  },

  showInputsLabel: true,
};


      window.NI.mountCardInput("ni-card-mount", {
        apiKey: config?.ApiKey,
        outletRef: config?.OutletRef,
        language: "en",
        supportedPaymentMethods: ["CARD"],
        style,
        onSuccess: () => {
          console.log("NI SDK mounted successfully.");
          setNIInitialized(true);
        },
        onFail: (err: any) => {
          console.error("NI SDK mount failed:", err);
          setNIInitialized(false);
          alert("Failed to load payment fields. Please try again.");
        },
        onChangeValidStatus: ({
        isCVVValid,
        isExpiryValid,
        isNameValid,
        isPanValid
      }:any) => {
        console.log('Field validation:', {
          isCVVValid,
          isExpiryValid,
          isNameValid,
          isPanValid
        });
        
        const overallValid = isCVVValid && isExpiryValid && isNameValid && isPanValid;
       
        setIsCardInputValid(overallValid);
        console.log('Overall Validity set to:', overallValid);
      },
    });}

    // Load SDK script if not already loaded
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = config?.NIUrl ?? "";
      script.async = true;
      script.onload = initWhenReady;
      document.body.appendChild(script);
    } else {
      initWhenReady();
    }

    // cleanup
    return () => {
      console.log("Unmounting NI card fields...");
      if (window.NI && typeof window.NI.unMountCardInputs === "function") {
        window.NI.unMountCardInputs();
      }
      setNIInitialized(false);
      setTokenizedCard(null);
      setNILoading(false);
    };
  }, [niCardModal]);

  return (
    <div
      style={{
        background: General.contrast.contrastBackground
          ? General.contrast.contrastColor
          : "#fff",
        width: "90%",
        margin: "auto",
        minHeight: "60vh",
      }}
    >
      <TabContainer style={{ display: "flex", flexDirection: "column" }}>
        <ButtonsContainer
          style={{
            display: "flex",
            paddingTop: "15px",
            justifyContent: "end",
            width: "98%",
          }}
        >
          <ButtonSecondary
            style={{
              width: "10rem",
              padding: "20px",
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : "#fff",
              background: General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : General?.ColorAss,
              fontSize: `${General.accessibility.fontSize}rem`,
              fontWeight: "bold",
              border: "none",
            }}
            onClick={() => {
              if (config?.isCheckout) {
                handleOpenCardsPopupModal();
              } else {
                handleOpen();
              }
            }}
            //className="DynamicButtonColor"
          >
            {General?.codeLabels["cm_add_card"]?.label !== undefined
              ? General?.codeLabels["cm_add_card"]?.label
              : "ADD NEW CARD"}
          </ButtonSecondary>
        </ButtonsContainer>
        {/* cardsStore.list.length > 0 */}
        {cardsStore?.list?.cards?.length > 0 ? (
          cardsStore?.list?.cards?.map((card: any) => (
            <div style={{ padding: "15px", }}>
              <Accordion
                defaultExpanded={
                  General?.paymentUpdateResponse?.previousPaymentId ==
                  card?.previousPaymentId
                    ? true
                    : false
                }
                style={{ position: "relative" }}
              >
                <AccordionSummary
                  expandIcon={
                    <>
                      <ExpandMoreIcon />{" "}
                    </>
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    display: "flex", 
    justifyContent: "space-between",
                    background: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : "#e5eff2"
                  }}
                >
                  <div style={{ flex: "0 0 25%" }}>
                    <Typography
                      className={General?.textClass}
                      sx={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "#101E8E",
                      }}
                    >
                      {card?.cardType}
                    </Typography>
                    <Typography
                      className={General?.textClass}
                      sx={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "#101E8E",
                      }}
                    >
                      ********{card?.cardNumber?.slice(-4)}
                    </Typography>
                  </div>
                  <div
                    style={{
                      marginRight:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "ARA"
                          ? "15vw"
                          : "",
                      marginLeft:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode != "ARA"
                          ? "15vw"
                          : "",
                    }}
                  >
                    <Typography
                      className={General?.textClass}
                      sx={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "#101E8E",
                      }}
                    >
                      {General?.codeLabels["cm_expiry_date"]?.label
                        ? General?.codeLabels["cm_expiry_date"]?.label
                        : "Expiry Date"}
                    </Typography>
                    <Typography
                      className={General?.textClass}
                      sx={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "#101E8E",
                      }}
                    >
                      {card?.expiryMonth} / {card?.expiryYear}
                    </Typography>
                  </div>
                  <img
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenDeleteModal(card);
                    }}
                    style={{
                      position: "absolute",
                      left:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "ARA"
                          ? "55px"
                          : "",
                      right:
                        General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode != "ARA"
                          ? General?.isLargeScreen
                            ? "55px"
                            : "20px"
                          : "",
                      top: "30px",
                    }}
                    src={DeleteIcon}
                    alt=""
                  />
                </AccordionSummary>
                <div
                  style={{
                    background: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : "#fff",
                  }}
                >
                  {card?.accounts?.map((account: any) => (
                    <AccordionDetails>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ width: "25%", maxWidth: "25%" }}>
                          <div
                            style={{
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_dname"]?.label
                              ? General?.codeLabels["cm_dname"]?.label
                              : "Name"}
                          </div>
                          <div
                            style={{
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                            }}
                          >
                            {account?.customerName}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_paymentdatedatatable"]
                              ?.label
                              ? General?.codeLabels["cm_paymentdatedatatable"]
                                  ?.label
                              : "Payment Date"}{" "}
                            <span style={{ marginLeft: "5px" }}>
                              <span
                                onClick={() =>
                                  handleOpenEditModal(account, card)
                                }
                              >
                                {editIcon(
                                  General.contrast.contrastBackground
                                    ? General.contrast.contrastBackground
                                    : General?.ColorAss
                                )}
                              </span>
                              {/* <img onClick={() => handleOpenEditModal(account, card)} src={EditIcon} alt="edit" /> */}
                            </span>
                          </div>
                          <div
                            style={{
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                              background: "rgba(229, 239, 242, 0.7)",
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "2px",
                              width: "100px",
                            }}
                          >
                            {account?.paymentDate}
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                            }}
                          >
                            {General?.codeLabels["cm_accountnopaymentstable"]
                              ?.label
                              ? General?.codeLabels["cm_accountnopaymentstable"]
                                  ?.label
                              : "Account Number"}
                          </div>
                          <div
                            style={{
                              marginTop: "2px",
                              color: contrast?.contrastBackground
                                ? contrast?.contrastBackground
                                : General.ColorAss,
                            }}
                          >
                            {account?.accountNo}
                          </div>
                          <div style={{display:'flex', flexDirection:'row',gap:'10px'}}>
                            <div style={{ marginTop: "20px"}}>
                            <ButtonSecondary
                              style={{
                                width: "12rem",
                                padding: "20px",
                                color: General.contrast.contrastColor
                                  ? General.contrast.contrastColor
                                  : General.ColorAss,
                                border: `1px solid ${
                                  General.contrast.contrastColor
                                    ? General.contrast.contrastColor
                                    : General.ColorAss
                                }`,
                                background: General.contrast.contrastBackground
                                  ? General.contrast.contrastBackground
                                  : "white",
                                fontSize: `${General.accessibility.fontSize}rem`,
                                fontWeight: "bold",
                              }}
                              // onClick={() => openDisableAutopayModal(card?.previousPaymentId,account?.accountId)}
                              onClick={() => {
                                openDisableAutopayModal(card?.previousPaymentId,account?.accountNo)
                                
                              }}


                              // className={General?.textClass}
                            >
                              {General?.codeLabels["cm_disable_autopay"]?.label !== undefined ? General?.codeLabels["cm_disable_autopay"]?.label :"DISABLE AUTOPAY"}
                            </ButtonSecondary>
                          </div>
                          <div style={{ marginTop: "20px" }}>
                            <ButtonSecondary
                              style={{
                                width: "10rem",
                                padding: "20px",
                                color: General.contrast.contrastColor
                                  ? General.contrast.contrastColor
                                  : General.ColorAss,
                                border: `1px solid ${
                                  General.contrast.contrastColor
                                    ? General.contrast.contrastColor
                                    : General.ColorAss
                                }`,
                                background: General.contrast.contrastBackground
                                  ? General.contrast.contrastBackground
                                  : "white",
                                fontSize: `${General.accessibility.fontSize}rem`,
                                fontWeight: "bold",
                              }}
                              onClick={() => {
                                setChangeCardData({
                                  card: cardsStore?.list?.cards?.filter(
                                    (newCard: any) =>
                                      newCard?.previousPaymentId !==
                                      card?.previousPaymentId
                                  ),
                                  account,
                                });
                                setCardChange(true);
                              }}
                              // className={General?.textClass}
                            >
                              {General?.codeLabels["cm_change_card"]?.label !==
                              undefined
                                ? General?.codeLabels["cm_change_card"]?.label
                                : "CHANGE CARD"}
                            </ButtonSecondary>
                          </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          height: "1px",
                          width: "100%",
                          background: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : "#E7E9F8",
                          marginTop: "20px",
                        }}
                      ></div>
                    </AccordionDetails>
                  ))}
                  {cardsStore?.list?.cards?.length > 0 && (
                    <ButtonsContainer
                      style={{
                        display: "flex",
                        height: "12vh",
                        justifyContent: "end",
                        width: "98%",
                      }}
                    >
                      <ButtonSecondary
                        style={{
                          width: "12rem",
                          padding: "20px",
                          color: General.contrast.contrastColor
                            ? General.contrast.contrastColor
                            : "#fff",
                          background: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                          fontSize: `${General.accessibility.fontSize}rem`,
                          fontWeight: "bold",
                          border: "none",
                        }}
                        onClick={() => {
                          handleOpenAccountsModal();
                          setpreviousPaymentId(card?.previousPaymentId);
                        }}
                        //className="DynamicButtonColor"
                      >
                        {General?.codeLabels["cm_add_new_acct"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_add_new_acct"]?.label
                          : "ADD NEW ACCOUNT"}
                      </ButtonSecondary>
                    </ButtonsContainer>
                  )}
                </div>
              </Accordion>
            </div>
          ))
        ) : (
          <div
            style={{
              height: "30vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontFamily: "Segoe UI",
                color: "#101E8E",
                fontWeight: "400",
                fontSize: `${General.accessibility.fontSize}rem`,
              }}
            >
              {General?.codeLabels["cm_msg_92000_108"]?.label
                ? General?.codeLabels["cm_msg_92000_108"]?.label
                : "No cards availabl"}
            </p>
          </div>
        )}
      </TabContainer>

      <Modal
        sx={{ "--bg-color": ColorAss ? ColorAss : "pink" }}
        open={cardsPopupModal}
        onClose={handleCloseCardsPopupModal}
      >
        <CardsPopup
          makePayment={handleMakePayment}
          fromAutoPay={true}
          paymentLoader={paymentLoader}
          onClose={handleCloseCardsPopupModal}
        />
      </Modal>
      <Modal open={editModal} onClose={() => setEditModal(false)}>
        <AmountEdit
          loader={editLoader}
          datValue={dateValue}
          saveAccounts={handleChangeDate}
          onClose={() => setEditModal(false)}
        />
      </Modal>
      <Modal open={accountsModal} onClose={handleCloseAccountsModal}>
        <Accounts
          onClose={handleCloseAccountsModal}
          saveAccounts={handleSaveAccounts}
          saveAccLoader={saveAccLoader}
        />
      </Modal>
      <Modal open={cardChange} onClose={handleCloseCardChange}>
        <ChangeCardModal
          changeCardData={changeCardData}
          changeCard={handleChangeCard}
          onClose={handleCloseCardChange}
        />
      </Modal>
      {disableAutoPayModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <DisableAutopay
            onClose={closeDisableAutopayModal}
            disableData={handleDisableAutoPay}
            loader={loader}
            previousPaymentId={disablePymentDetails?.previousPaymentId}
            accountId={disablePymentDetails?.accountId}
          />
        </div>)}

      <Modal
        open={delModalOpen}
        onClose={() => setDELModalOpen(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <DelCardModal
          onClose={() => setDELModalOpen(false)}
          delData={handleDeleteCard}
          loader={loader}
        />
      </Modal>
      {niCardModal && (
        <Modal
          open={niCardModal}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown")
              return;
            handleClose();
          }}
          aria-labelledby="ni-card-modal-title"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          disableEscapeKeyDown
        >
          <div className={styles.niCardModal}>
            <div className={styles.niCardHeader} style={{
            background: General.contrast.contrastBackground
              ? General.contrast.contrastBackground
              : General?.ColorAss,
            height: "70px",
            width: "100%",
          }}>
              <h4 id="ni-card-modal-title" style={{
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : '#fff',
              fontSize: `${1.875 * General.accessibility.fontSize}rem`,
              fontFamily: "Segoe UI",
              fontWeight: "400",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70px",
              width: "100%",
              marginTop: "0px",
            }}>
                {General?.codeLabels["cm_add_card"]?.label !== undefined
                  ? General?.codeLabels["cm_add_card"]?.label
                  : "ADD NEW CARD"}

                
              </h4>
            </div>
            <div id="ni-card-mount" className={styles.niCardMount}>
              {!niInitialized && (
  <div className={styles.loaderBox}>
    <Spinner/>
    <p>Please wait…</p>
  </div>
)}
            </div>
            {niInitialized && !niLoading &&(
               <div className={styles.termsContainer}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                />
                I agree to the<a href="https://www.ajmansewerage.ae/home/disclaimer"
                  style={{ color: "#007bff", textDecoration: 'underline'}}
                  target="_blank"
                  rel="noopener noreferrer">Terms & Conditions</a>
              </label>
  </div>
            )}
           
            <div className={styles.niCardActions}>
              <button
                className={styles.btnSecondary}
                onClick={() => {
                  handleClose();
                  setNi3dsModal(false);
                }}
                disabled={niLoading}
              >
                {General?.codeLabels["cm_cancel"]?.label !== undefined
                  ? General?.codeLabels["cm_cancel"]?.label
                  : "Cancel"}
                 
              </button>
              <button
                className={styles.btnPrimary}
                onClick={handleSaveCard}
                disabled={niLoading || !isCardInputValid || !agreeTerms}
              >
                {General?.codeLabels["cm_save_card"]?.label !== undefined
                  ? General?.codeLabels["cm_save_card"]?.label
                  : "Save Card"}
                
              </button>
            </div>
          </div>
        </Modal>
      )}
      {ni3dsModal && (
        <Modal
          open={ni3dsModal}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown")
              return;
            setNi3dsModal(false);
          }}
          disableEscapeKeyDown
          aria-labelledby="ni-3ds-modal-title"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className={styles.niCardModal}>
            <div className={styles.niCardHeader}>
              <h3 id="ni-3ds-modal-title" className={styles.headingH3}>
                3D Secure Verification
              </h3>
            </div>
            <div
              id="ni-3ds-frame"
              style={{
                marginTop: "1rem",
                height:"400px",
                minHeight: "400px",
                maxHeight: "400px",
                display: "flex",
                justifyContent: "center",
              }}
            ></div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default observer(AutoPay);
